import { httpCreate } from './http';

const http = httpCreate('/srv/prize');

export const prize = {
	//卡券/实物获奖列表
	winList(id, data, params) {
		return http.post(`/winList/${id}`, data, { params });
	},
	//删除卡券/实物
	delPrize(id) {
		return http.delete(`/${id}`);
	},
	//卡券/实物列表
	getList(params) {
		return http.get('/list', { params });
	},
	//修改卡券/实物
	changePrize(id, data) {
		return http.put(`/${id}`, data);
	},
	//新增卡券/实物
	addPrize(data) {
		return http.post('', data);
	},
	//卡券&&实物列表
	getAllList(params = {}) {
		return http.get('/pull-down/list', { params });
	},
	// 卡卷/实物核销
	doVerdict(id, formData) {
		return http.post(`/doVerdict/${id}`, formData);
	},
};
